import { render } from "./LoginLayout.vue?vue&type=template&id=c5bd9dc8&scoped=true"
import script from "./LoginLayout.vue?vue&type=script&lang=js"
export * from "./LoginLayout.vue?vue&type=script&lang=js"

import "./LoginLayout.vue?vue&type=style&index=0&id=c5bd9dc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c5bd9dc8"]])

export default __exports__